<template>
  <!--
          作者：kmdshop
          时间：2019-10-24
          描述：登录页面
      -->
      <div class="ba_f outerLayer">
    <div class="sellback" id="box">
      <div class="login_wrap">
        <div class="warp_content">
          <div class="title">
            <h3>商家管理后台登录</h3>
            <span class="txt"></span>
          </div>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
            <el-form-item prop="userName">
              <el-input prefix-icon="iconfont iconzhanghao mar_l5" v-model="ruleForm.account" autocomplete="off" placeholder="请输入登录账号" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input prefix-icon="iconfont iconmima mar_l5" v-model="ruleForm.checkPass" autocomplete="off" type="password" placeholder="请输入密码" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item prop="yzm">
              <el-input size="large" prefix-icon="iconfont iconmima mar_l5" v-model="ruleForm.yzm" autocomplete="off" placeholder="请输入图形验证码" style="width: 300px" class="yzm">
                <el-button slot="append">
                  <canvas @click="getYzm" id="canvas" width="120" height="40"></canvas>
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 300px;" @click.native.prevent="SubmitFunc" @keyup.enter.native="SubmitFunc">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import "@/assets/css/loginysw.css";
import IndexApi from "@/api/index.js";
import { yzm } from '@/assets/js/yzm';
import bgimg from "@/assets/img/login_bg.jpg";
import UserApi from "@/api/user.js";
import { setCookie, setSessionStorage, delCookie } from "@/utils/base.js";
export default {
  data() {
    var yzm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        setTimeout(() => {
          callback();
        }, 1000);
      }
    };
    return {
      /*是否正在加载*/
      loading: true,
      /*背景图片*/
      bgimg_url: bgimg,
      /*是否正在提交*/
      logining: false,
      pathroute: "",
      /*表单对象*/
      ruleForm: {
        /*用户名*/
        account: "",
        /*密码*/
        checkPass: "",
        // 验证码
         yzm: ''
      },
      /*验证规则*/
      rules: {
        /*用户名*/
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        /*密码*/
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      /*基础配置*/
      baseData: {},
      icp :'',
    };
  },
  mounted() {
    yzm(1);
  },
  created() {
    delCookie('token');
    this.getData();
    if (process.env.NODE_ENV !== 'production') {
      this.ruleForm.account = process.env.NODE_USER
      this.ruleForm.checkPass = process.env.NODE_PASS
    }
  },
  methods: {
    getYzm() {
      yzm();
    },
    /*获取基础配置*/
    getData() {
      let self = this;
      IndexApi.base({})
        .then((res) => {
          console.log(res)
          if(res.data.config.icp != ''){
            self.icp = res.data.config.icp;
          }
          if(res.data.config.kmd_support=="w7"){
            // locaotion.href="../../../web"
            // console.log(window.location);
            window.location.href = window.location.protocol + '//' + window.location.host;
          }
        })
        .catch((error) => {
          self.loading = false;
        });

    },

    /*登录方法*/
    SubmitFunc() {

      if (this.ruleForm.yzm != sessionStorage.getItem('yzm')) {
          this.$message({
                  message: "请输入正确的验证码",
                  type: "error",
                });
          return false;
        }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          var Params = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass,
          };
          /*调用登录接口*/
          UserApi.login(Params, true)
            .then((res) => {
              console.log(res);
              this.logining = false;
              if (res.code == 1) {
                /*保存个人信息*/
                setCookie("userinfo", res.data);
                if(res.data.supply){
                  setCookie("is_supply", 1);
                }else{
                  setCookie("is_supply", 0);
                }
                if(res.data.token != undefined){
                  setCookie("token", res.data.token);
                }
                /*设置一个登录状态*/
                setCookie("isLogin", true);
                this.pathroute = res.data.path;
                console.log(this.pathroute);
                /*跳转到首页*/
                if (this.pathroute != "") {
                  this.$router.push({ path: this.pathroute });
                } else {
                  this.$router.push({ path: "/" });
                }
              } else {
                this.$message({
                  message: "登录失败",
                  type: "error",
                });
              }
            })
            .catch((error) => {
              //接口调用方法统一处理
              this.logining = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.login-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center;
  //background-size: 100%;
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.4);

  .title {
    margin: 0 auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 10px;
  }
  .title1 {
    margin: 20px auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-top: 1px solid #d6d6d6;
    padding-top: 10px;
  }
  .remember {
    margin: 0 0 35px 0;
  }
}



.yzm {
  .el-button {
    padding: 0 0 !important;
  }
}

.login_wrap {
  width: 420px;
  background: #fff;
  border-radius: 5px;
}

.el-input--prefix .el-input__inner {
  padding-left: 35px;
}

.outerLayer {
  width: 100%;
  height: 100%;
  background: url(../../static/imgs/bg.jpg) no-repeat;
  background-size: cover;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
  align-items: center;
}

.sellback {
  width: 420px;
  height: 430px;
  margin: 10% auto 0 auto;
  background-color: #fff;
  border-radius: 10px;
}

.warp_content {
  width: 300px;
  margin: 0 auto;
  padding-top: 20px;
  text-align: center;
}

.warp_content .title {
  margin-top: 10px;
  padding-bottom: 30px;
  margin-bottom: 40px;
  border-bottom: 1px solid #eee;
}

.warp_content .title h3 {
  font-size: 20px;
  color: #333;
  line-height: 32px;
}

.formInfo {
  margin-top: 30px;
  overflow: hidden;
}

.formInfo .formText {
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}

.formInfo .formText .input-text {
  border: 0;
  height: 42px;
  padding: 6px 28px 6px 18px;
  width: 340px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.formInfo .formText input:focus {
  outline: none;
  box-shadow: none;
}

.formInfo .formText .login-icon {
  position: absolute;
  top: 9px;
  left: 18px;
  width: 14px;
  height: 13px;
  z-index: 9;
  border-right: 1px solid #e3e4e8;
  height: 30px;
  width: 30px;
}

.formInfo .submitDiv {
  font-size: 0;
  padding-top: 20px;
}

.passwordText {
  height: 20px;
  line-height: 20px;
}

.passwordl {
  float: left;
  height: 20px;
  line-height: 20px;
}

.passwordl .check {
  width: 17px;
  height: 17px;
  border: 1px solid #d4d4d4;
  background-color: #fff;
}

.passwordl label {
  margin-top: -10px;
  margin-left: 3px;
}

.passwordr {
  float: right;
  color: #999;
}

.passwordr a {
  font-size: 14px;
  color: #999;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue